import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import {
  Col,
  FormFeedback,
  Input,
  Row,
  Table,
} from "reactstrap";
import * as Yup from "yup";

import ToastDialog from "components/Common/ToastDialog";
import "./style.scss";

import {
  getBorrowingList,
} from "http/fundLync/entityAndAddress.helper";
import { decryptedValue, formatNumberToCrores, isPermission } from "common/utility";
import { callBankList, callfinListSummary } from "http/fundLync/common.helper";
import { useAsyncDebounce } from "react-table";
import PropTypes from "prop-types";
import { addCamData, editCamData, getCamData } from "http/fundLync/cam.helper";

// TableRow Component
const TableRow = ({ onDelete, index, validation,}) => {


  const handleInputChange = (index, field, value, label) => {
    validation.setFieldValue(`customerList.${index}.${field}`, value);
  };

  return (
    <tr>
        <td  className="width-dynamic-field">
          <Input
            type="text"
            placeholder="Enter Customer Name"
            name={`customer[${index}].name`}
            id={`customer[${index}].name`}
            value={validation.values.customerList[index].name}
            onChange={(event) => {
              handleInputChange(index, "name", event.target.value);
            }}
            invalid={
              validation.touched.customerList?.[index]?.name &&
                validation.errors.customerList?.[index]?.name
                ? true
                : false
            }
          />
          {validation.touched.customerList?.[index]?.name &&
            validation.errors.customerList?.[index]?.name && (
              <FormFeedback>
                {validation.errors.customerList?.[index]?.name}
              </FormFeedback>
            )}
        </td>
        <td className="width-dynamic-field">
          <Input
            type="text"
            placeholder="Enter Product"
            name={`customer[${index}].product`}
            id={`customer[${index}].product`}
            value={validation.values.customerList[index].product}
            onChange={(event) => {
              handleInputChange(index, "product", event.target.value);
            }}
            invalid={
              validation.touched.customerList?.[index]?.product &&
                validation.errors.customerList?.[index]?.product
                ? true
                : false
            }
          />
          {validation.touched.customerList?.[index]?.product &&
            validation.errors.customerList?.[index]?.product && (
              <FormFeedback>
                {validation.errors.customerList?.[index]?.product}
              </FormFeedback>
            )}
        </td>
        <td className="width-dynamic-field">
          <Input
            type="text"
            placeholder="Enter Country"
            name={`customer[${index}].country`}
            id={`customer[${index}].country`}
            value={validation.values.customerList[index].country}
            onChange={(event) => {
              handleInputChange(index, "country", event.target.value);
            }}
            // invalid={
            //   validation.touched.customerList?.[index]?.country &&
            //     validation.errors.customerList?.[index]?.country
            //     ? true
            //     : false
            // }
          />
          {/* {validation.touched.customerList?.[index]?.country &&
            validation.errors.customerList?.[index]?.country && (
              <FormFeedback>
                {validation.errors.customerList?.[index]?.country}
              </FormFeedback>
            )} */}
        </td>
        <td className="width-dynamic-field">
          <Input
            type="text"
            placeholder="Enter Amount"
            name={`customer[${index}].amount`}
            id={`customer[${index}].amount`}
            value={validation.values.customerList[index].amount}
            onChange={(event) => {
              handleInputChange(index, "amount", event.target.value);
            }}
            // invalid={
            //   validation.touched.customerList?.[index]?.amount &&
            //     validation.errors.customerList?.[index]?.amount
            //     ? true
            //     : false
            // }
          />
          {/* {validation.touched.customerList?.[index]?.amount &&
            validation.errors.customerList?.[index]?.amount && (
              <FormFeedback>
                {validation.errors.customerList?.[index]?.amount}
              </FormFeedback>
            )} */}
        </td>
        <td className="width-dynamic-field">
          <Input
            type="text"
            placeholder="Enter Credit Period"
            name={`customer[${index}].creditPeriod`}
            id={`customer[${index}].creditPeriod`}
            value={validation.values.customerList[index].creditPeriod}
            onChange={(event) => {
              handleInputChange(index, "creditPeriod", event.target.value);
            }}
            // invalid={
            //   validation.touched.customerList?.[index]?.creditPeriod &&
            //     validation.errors.customerList?.[index]?.creditPeriod
            //     ? true
            //     : false
            // }
          />
          {/* {validation.touched.customerList?.[index]?.creditPeriod &&
            validation.errors.customerList?.[index]?.creditPeriod && (
              <FormFeedback>
                {validation.errors.customerList?.[index]?.creditPeriod}
              </FormFeedback>
            )} */}
        </td>
      <td className="width-dynamic-field">
        {validation.values?.customerList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );
};
const TableRowSuppier = ({ onDelete,  index, validation }) => {
   
    const handleInputChange = (index, field, value, label) => {
      validation.setFieldValue(`supplierList.${index}.${field}`, value);
    };
  
    return (
        <tr>
            <td  className="width-dynamic-field">
              <Input
                type="text"
                placeholder="Enter Customer Name"
                name={`customer[${index}].name`}
                id={`customer[${index}].name`}
                value={validation.values.supplierList[index].name}
                onChange={(event) => {
                  handleInputChange(index, "name", event.target.value);
                }}
                invalid={
                  validation.touched.supplierList?.[index]?.name &&
                    validation.errors.supplierList?.[index]?.name
                    ? true
                    : false
                }
              />
              {validation.touched.supplierList?.[index]?.name &&
                validation.errors.supplierList?.[index]?.name && (
                  <FormFeedback>
                    {validation.errors.supplierList?.[index]?.name}
                  </FormFeedback>
                )}
            </td>
            <td className="width-dynamic-field">
              <Input
                type="text"
                placeholder="Enter Product"
                name={`customer[${index}].product`}
                id={`customer[${index}].product`}
                value={validation.values.supplierList[index].product}
                onChange={(event) => {
                  handleInputChange(index, "product", event.target.value);
                }}
                invalid={
                  validation.touched.supplierList?.[index]?.product &&
                    validation.errors.supplierList?.[index]?.product
                    ? true
                    : false
                }
              />
              {validation.touched.supplierList?.[index]?.product &&
                validation.errors.supplierList?.[index]?.product && (
                  <FormFeedback>
                    {validation.errors.supplierList?.[index]?.product}
                  </FormFeedback>
                )}
            </td>
            <td className="width-dynamic-field">
              <Input
                type="text"
                placeholder="Enter Country"
                name={`customer[${index}].country`}
                id={`customer[${index}].country`}
                value={validation.values.supplierList[index].country}
                onChange={(event) => {
                  handleInputChange(index, "country", event.target.value);
                }}
                // invalid={
                //   validation.touched.supplierList?.[index]?.country &&
                //     validation.errors.supplierList?.[index]?.country
                //     ? true
                //     : false
                // }
              />
              {/* {validation.touched.supplierList?.[index]?.country &&
                validation.errors.supplierList?.[index]?.country && (
                  <FormFeedback>
                    {validation.errors.supplierList?.[index]?.country}
                  </FormFeedback>
                )} */}
            </td>
            <td className="width-dynamic-field">
              <Input
                type="text"
                placeholder="Enter Amount"
                name={`customer[${index}].amount`}
                id={`customer[${index}].amount`}
                value={validation.values.supplierList[index].amount}
                onChange={(event) => {
                  handleInputChange(index, "amount", event.target.value);
                }}
                // invalid={
                //   validation.touched.supplierList?.[index]?.amount &&
                //     validation.errors.supplierList?.[index]?.amount
                //     ? true
                //     : false
                // }
              />
              {/* {validation.touched.supplierList?.[index]?.amount &&
                validation.errors.supplierList?.[index]?.amount && (
                  <FormFeedback>
                    {validation.errors.supplierList?.[index]?.amount}
                  </FormFeedback>
                )} */}
            </td>
            <td className="width-dynamic-field">
              <Input
                type="text"
                placeholder="Enter Credit Period"
                name={`customer[${index}].creditPeriod`}
                id={`customer[${index}].creditPeriod`}
                value={validation.values.supplierList[index].creditPeriod}
                onChange={(event) => {
                  handleInputChange(index, "creditPeriod", event.target.value);
                }}
                // invalid={
                //   validation.touched.supplierList?.[index]?.creditPeriod &&
                //     validation.errors.supplierList?.[index]?.creditPeriod
                //     ? true
                //     : false
                // }
              />
              {/* {validation.touched.supplierList?.[index]?.creditPeriod &&
                validation.errors.supplierList?.[index]?.creditPeriod && (
                  <FormFeedback>
                    {validation.errors.supplierList?.[index]?.creditPeriod}
                  </FormFeedback>
                )} */}
            </td>
          <td style={{ width: "10%" }}>
            {validation.values?.supplierList?.length > 1 && (
              <i
                className="bx bx-x-circle text-danger"
                onClick={() => onDelete(index)}
                style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
              />
            )}
          </td>
        </tr>
      );
  };
// BorrowingProfile Component
const CamCustomerSupplier  = forwardRef((props, ref) => {
  document.title = "Customer / Supplier Details | FundLync"
  const { queryString } = props; 
  const [rows, setRows] = useState([
    {
      name: "",
      product: "",
      country: "",
      amount: "",
      creditPeriod: "",
    },
  ]);
  const [rowSupplier, setRowsSuppliers] = useState([
    {
      name: "",
      product: "",
      country: "",
      amount: "",
      creditPeriod: "",
    },
  ]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [editMode, setEditMode] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const [entityId, setEntityId] = useState('');
  const [encodedId, setEncodedId] = useState('');
  const encodedDealId = urlParams.get("dealId");
  const dealId = atob(encodedDealId);
  const [camData, setCamData] = useState([]) 

  // Fetch data
 

  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
      
  },[ entityId, encodedId])


  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await getCamData({ dealId });
        setCamData([response?.data[0]]);
        const data = response?.data[0]
        if (response?.status && data?.customerSupplier != null) {
          setRows(data?.customerSupplier?.customerList);
          setRowsSuppliers(data?.customerSupplier?.supplierList);
        } 

      } catch (error) {
        console.error("Error loading data:", error);
      }
    };
    loadData()
  }, [entityId]);


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      customerList: rows || [
        {
            name: "",
            product: "",
            country: "",
            amount: "",
            creditPeriod: "",
          },
      ],
      supplierList: rowSupplier || [
        {
            name: "",
            product: "",
            country: "",
            amount: "",
            creditPeriod: "",
          },
      ],
    },

    validationSchema: Yup.object({
      // customerList: Yup.array().of(
      //   Yup.object({
      //     name: Yup.string().required("Lender name is required"),
      //     product: Yup.string().required("Lender Type is required"),
      //     country: Yup.string().required("Lender Type is required"),
      //     amount: Yup.number()
      //       .typeError("amount must be a number")
      //       .required("Sanctioned amount is required")
      //       .min(0, "Sanctioned amount cannot be negative"),
      //     creditPeriod: Yup.string().required("Lender Type is required"),
          
      //   })
      // ),
      // supplierList: Yup.array().of(
      //   Yup.object({
      //     name: Yup.string().required("Lender name is required"),
      //     product: Yup.string().required("Lender Type is required"),
      //     country: Yup.string().required("Lender Type is required"),
      //     amount: Yup.number()
      //       .typeError("amount must be a number")
      //       .required("Sanctioned amount is required")
      //       .min(0, "Sanctioned amount cannot be negative"),
      //     creditPeriod: Yup.string().required("Lender Type is required"),
          
      //   })
      // ),
      customerList: Yup.array()
              .of(
                Yup.object({
                  name: Yup.string().test(
                    "required-after-first",
                    "Title is required for entries after the first one",
                    function (value, context) {
                      const index = context?.options?.index;
                      return index === 0 || (value && value.trim() !== "");
                    }
                  ),
                  product: Yup.string().test(
                    "required-after-first",
                    "Strength is required for entries after the first one",
                    function (value, context) {
                      const index = context?.options?.index;
                      return index === 0 || (value && value.trim() !== "");
                    }
                  ),
                })
              )
              .required(" cutomers must be an array")
              .min(1, "At least one customer is required"),
              supplierList: Yup.array()
              .of(
                Yup.object({
                  name: Yup.string().test(
                    "required-after-first",
                    "name is required for entries after the first one",
                    function (value, context) {
                      const index = context?.options?.index;
                      return index === 0 || (value && value.trim() !== "");
                    }
                  ),
                  product: Yup.string().test(
                    "required-after-first",
                    "product is required for entries after the first one",
                    function (value, context) {
                      const index = context?.options?.index;
                      return index === 0 || (value && value.trim() !== "");
                    }
                  ),
                })
              )
              .required("supplier must be an array")
              .min(1, "At least one supplier is required")
    }),

    onSubmit: (values) => {
      if (camData.length > 0) {
        const entity = {
          aboutSection: camData[0]?.aboutSection,
          directorSharehodlerList: camData[0]?.directorSharehodlerList,
          keyStrength:  camData[0]?.keyStrength,
          finSummary: camData[0]?.finSummary,
          debtProfile: camData[0]?.debtProfile,
          customerSupplier: {
            customerList: values.customerList,
            supplierList: values.supplierList,
          },
          termsheet: camData[0]?.termsheet,
          entityId: entityId,
          dealId: dealId,
          id: camData[0]?.id,
          lastVisitedStep: "termsheet" || null,
        }
        editCamData(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Cam Data Updated",
                showToast: true,
                role: "success",
              });
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          }) 
          .catch((err) => {
            console.log(err);
          });
      } else {
        const entity = {
          aboutSection: camData[0]?.aboutSection,
          directorSharehodlerList: camData[0]?.directorSharehodlerList,
          keyStrength: camData[0]?.keyStrength,
          finSummary: camData[0]?.finSummary,
          debtProfile: camData[0]?.debtProfile,
          customerSupplier: {
            customerList: values.customerList,
            supplierList: values.supplierList,
          },
          termsheet: camData[0]?.termsheet,
          entityId: entityId,
          dealId: dealId,
          id: camData[0]?.id,
          lastVisitedStep: "termsheet" || null,
        };
        addCamData(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Cam Data Saved",
                showToast: true,
                role: "success",
              })
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
        }
    },
  });
  useImperativeHandle(ref, () => ({
    handleSubmit: () => validation.handleSubmit(),
    getValidationStatus: () =>
      validation.validateForm().then((errors) => Object.keys(errors).length === 0),
  }));

  const handleDelete = (rowIndex) => {
    validation.values.customerList.splice(rowIndex, 1);
    validation.validateForm();
  };
  const handleDeleteSupplier = (rowIndex) => {
    validation.values.supplierList.splice(rowIndex, 1);
    validation.validateForm();
  };

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  return (
    <React.Fragment>
        <FormikProvider value={validation}>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
                  <div>
                        <h5 style={{ color: "#42B763" }}>Customer Details</h5>
                      </div>
                  <Row>
                    <Col sm="12">
                      <div className="table-responsive react-table">
                        <Table
                          Table
                          striped
                          bordered
                          hover
                          className="responsive-table"
                          style={{ width: "100%", backgroundColor: "white" }}
                        >
                          <thead className="d-md-table-header-group">
                            <tr>
                              <th>Customer Name </th>
                              <th>Product </th>
                              <th>Country </th>
                              <th>Amount in Cr. </th>
                              <th>Credit Period </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <FieldArray
                              name="customerList"
                              render={(arrayHelpers) => (
                                <>
                                  {validation.values.customerList.map(
                                    (lender, index) => (
                                      <TableRow
                                        key={lender.id}
                                        onDelete={handleDelete}
                                        index={index}
                                        validation={validation}
                                      />
                                    )
                                  )}
                                  <tr>
                                    <td colSpan={6}>
                                      <span
                                        className="text-success"
                                        style={{ cursor: "pointer" }}
                                        onKeyUp={() => { }}
                                        onClick={() => {
                                          arrayHelpers.push({
                                            name: "",
                                            product: "",
                                            country: "",
                                            amount: "",
                                            creditPeriod: "",
                                          });
                                        }}
                                      >
                                        <i className="mdi mdi-plus me-1" /> Add
                                        Customer
                                      </span>
                                    </td>
                                  </tr>
                                </>
                              )}
                            />
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                  <div>
                        <h5 style={{ color: "#42B763" }}>Supplier Details</h5>
                      </div>
                  <Row>
                    <Col sm="12">
                      <div className="table-responsive react-table">
                        <Table
                          Table
                          striped
                          bordered
                          hover
                          className="responsive-table"
                          style={{ width: "100%", backgroundColor: "white" }}
                        >
                          <thead className="d-md-table-header-group">
                            <tr>
                              <th>Supplier Name </th>
                              <th>Product </th>
                              <th>Country </th>
                              <th>Amount in Cr. </th>
                              <th>Credit Period </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <FieldArray
                              name="supplierList"
                              render={(arrayHelpers) => (
                                <>
                                  {validation.values.supplierList.map(
                                    (lender, index) => (
                                      <TableRowSuppier
                                        key={lender.id}
                                        onDelete={handleDeleteSupplier}
                                        index={index}
                                        validation={validation}
                                      />
                                    )
                                  )}
                                  <tr>
                                    <td colSpan={6}>
                                      <span
                                        className="text-success"
                                        style={{ cursor: "pointer" }}
                                        onKeyUp={() => { }}
                                        onClick={() => {
                                          arrayHelpers.push({
                                            name: "",
                                            product: "",
                                            country: "",
                                            amount: "",
                                            creditPeriod: "",
                                          });
                                        }}
                                      >
                                        <i className="mdi mdi-plus me-1" /> Add
                                        Supplier
                                      </span>
                                    </td>
                                  </tr>
                                </>
                              )}
                            />
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
               
            </Form>
          </FormikProvider>
      
      {/* </Card> */}
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
});

CamCustomerSupplier.propTypes = {
  history: PropTypes.object,
};

CamCustomerSupplier.displayName = "CamCustomerSupplier"
export default CamCustomerSupplier;